module.exports = __webpack_public_path__ + "static/media/macbook_pro.81db5fec.jpg";